import react from 'react';

class Test extends react.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div>
                <object type="text/html" data={"https://heatmap-dc0da.web.app/?location="+this.props.location+"&country="+this.props.country} style={{width:"725px",height:"562px",overflow:"auto"}}>
                </object>
            </div>
        );
    }
}

export default Test;